import { NavLink, useLocation } from "react-router-dom";
import { Store, Flame, Gift, ShieldCheck, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const item = "flex-1 flex flex-col items-center justify-center gap-1 h-full text-[11px] font-medium transition-colors";
const tabCls = ({ isActive }) => `${item} ${isActive ? "text-emerald-400" : "text-gray-400 active:text-white"}`;

const TABS = [
  ["/", "Store", Store, "store"],
  ["/offers", "Offers", Flame, "offers"],
  ["/mystery", "Mystery", Gift, "mystery"],
  ["/order", "Track", ShieldCheck, "track"],
];

export const BottomNav = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-50 border-t border-white/10 bg-[#08090C]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
      <div className="h-16 flex">
        {TABS.map(([to, label, Icon, id]) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={`bottom-nav-${id}`} className={tabCls}>
            <Icon size={20} /> {label}
          </NavLink>
        ))}
        <button data-testid="bottom-nav-cart" onClick={() => setOpen(true)} className={`${item} text-gray-400 active:text-white`}>
          <span className="relative">
            <ShoppingBag size={20} />
            {count > 0 && <span data-testid="bottom-nav-cart-count" className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 rounded-full bg-emerald-500 text-[#08090C] text-[10px] font-bold grid place-items-center">{count}</span>}
          </span>
          Cart
        </button>
      </div>
    </nav>
  );
};
